import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { pill, pillActive, pills } from './styles.ve.css';

interface WizardProgressProps {
    count: number;
    activeIndex: number;
    maxReachedIndex?: number;
    onNavigate?: (index: number) => void;
}

export const WizardProgress = ({
    count,
    activeIndex,
    maxReachedIndex = activeIndex,
    onNavigate,
}: WizardProgressProps) => (
    <Stack
        className={pills}
        alignItems="center"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={count}
        aria-valuenow={activeIndex + 1}
    >
        {Array.from({ length: count }).map((_, i) => {
            const reachable = onNavigate && i <= maxReachedIndex;

            return (
                <button
                    key={i}
                    type="button"
                    className={i === activeIndex ? pillActive : pill}
                    onClick={reachable ? () => onNavigate(i) : undefined}
                    style={{ cursor: reachable ? 'pointer' : 'default', border: 'none', padding: 0 }}
                    aria-label={`Go to step ${i + 1}`}
                    disabled={!reachable}
                />
            );
        })}
    </Stack>
);
